export default __webpack_public_path__ + "static/media/Po-Sha Longsword.9e7f2969.jpg";